import React, {Component} from "react";
import {connect} from "react-redux";
import axios from "axios";
import Auth from "../../libs/auth";

axios.defaults.withCredentials = true;
const SERVER = process.env.API_URL + "/admin/customers/";
const CUSTOMER = process.env.API_URL + '/admin/customers/customer_info/';

class CloneDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerId: props.storeData.current_customer,
      isLoading: true,
      customerinfo: null,
      message: null,
      errorMessage: null,
      submitClone: false,
      email: "",
      password: ""
    };
  }

  componentDidMount() {
    this.getCustomerInfo();
  }

  getCustomerInfo = () => {
    let config = {
      headers: Auth.getHeader()
    };
    axios.get(CUSTOMER + this.state.customerId, config)
      .then((response) => {
        this.setState({
          customerInfo: response.data.data,
          isLoading: false
        });
      })
      .catch((err) => {
        console.error(err.response);
        Auth.isUnauthorized(err.response.status);
      });
  }

  createClone = (e) => {
    e.preventDefault();
    this.setState({message: null, errorMessage: null, submitClone: true})
    const { email, password } = this.state;
    let config = {
      headers: Auth.getHeader()
    };
    const data = {
      email,
      password
    }
    axios.post(SERVER + this.state.customerId + '/clone', data, config)
      .then((response) => {
        this.setState({message: response.data.message});
      })
      .catch((err) => {
        this.setState({errorMessage: err.response.data.message, submitClone: false});
      });
  };

  handleInputChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  };

  render() {
    const {
      errorMessage,
      message,
      isLoading,
    } = this.state;
    return (
      <div className="animated fadeIn">
        {isLoading ? (
          <div className="preloader loader-small"/>
        ) : (
          <div>
            <div className="card">
              <div className="card-header">
                <i className="fas fa-edit"/> Clone
                <div className="card-actions">
                  <a href="http://zenledger.io">
                    <small className="text-muted"/>
                  </a>
                </div>
              </div>
              <div className="row col-sm-12 my-3">
                <div className="col-sm-11">
                  <h5>Cloning {this.state.customerInfo.email}</h5>
                </div>
                <div className="col-sm-1">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => this.props.showTaxDetail()}
                  >
                    Back
                  </button>
                </div>
              </div>
              <div className="">
                <div className="row col-sm-12 pb-5">
                  <form className="col-sm-12" onSubmit={this.createClone}>
                    <div className="form-group">
                      <label htmlFor="emailInput">Email address</label>
                      <input
                        type="email"
                        className="form-control"
                        id="emailInput"
                        name="email"
                        value={this.state.email}
                        onChange={this.handleInputChange}
                        placeholder="Enter email"
                        style={{maxWidth: '400px'}}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="passwordInput">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        id="passwordInput"
                        name="password"
                        value={this.state.password}
                        onChange={this.handleInputChange}
                        placeholder="Password"
                        style={{maxWidth: '400px'}}
                        required
                      />
                    </div>
                    <button
                      type="submit"
                      className={`btn ${this.state.submitClone ? "btn-disabled" : "btn-primary"}`}
                      disabled={this.state.submitClone}
                      style={{
                        cursor: this.state.submitClone ? "not-allowed" : "pointer"
                      }}
                    >
                      Submit
                    </button>
                    {message && (
                      <div className="mt-3 alert alert-info">{message}</div>
                    )}
                    {errorMessage && (
                      <div className="mt-3 alert alert-danger">{errorMessage}</div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showTaxDetail: customer => {
      dispatch({
        type: "ENABLE_CL",
        payload: customer
      });
    }
  };
};

export default connect(null, mapDispatchToProps)(CloneDetail);
